import { render, staticRenderFns } from "./r-search-dialog.vue?vue&type=template&id=18644066&scoped=true"
import script from "./r-search-dialog.vue?vue&type=script&lang=js"
export * from "./r-search-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-search-dialog.vue?vue&type=style&index=0&id=18644066&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18644066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18644066')) {
      api.createRecord('18644066', component.options)
    } else {
      api.reload('18644066', component.options)
    }
    module.hot.accept("./r-search-dialog.vue?vue&type=template&id=18644066&scoped=true", function () {
      api.rerender('18644066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/search/r-search-dialog.vue"
export default component.exports